import { HorizontalScroll } from "components/Pagination/HorizontalScroll";
import { getSubDomain, useIsSubdomain } from "lib/host";
import { isBrowser } from "lib/ssr";
import { useAuthStore } from "modules/Auth/authStore";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { useGetCoursesByTenantSlug } from "./homeTenantApi";
import { getCookie } from "lib/helper";
import { trackEventGA, trackEventGTM } from "lib/amplitude";

interface KeywordsProp {
  setDataPaginate: any;
  pageKeywords: any;
  setPageKeywords: (a: any) => void;
  hasNextPage: boolean;
  setHasNextPage: (a: boolean) => void;
  isLoadingKeywords: boolean;
  setIsLoadingKeywords: (a: boolean) => void;
  itemsPerPage?: number;
  keywordOthers?: any[];
  onReset?(): void;
  setKeywordOthers?: (a: any) => void;
  setCoursesAfterClicked?: (a: any) => void;
}

const Keywords: React.FC<KeywordsProp> = ({
  setDataPaginate,
  pageKeywords,
  setPageKeywords,
  hasNextPage,
  setHasNextPage,
  isLoadingKeywords,
  setIsLoadingKeywords,
  itemsPerPage,
  keywordOthers,
  onReset,
  setKeywordOthers,
  setCoursesAfterClicked,
}) => {
  const { currentUser } = useAuthStore((state) => ({
    loginState: state.loginState,
    currentUser: state.currentUser,
  }));
  const subDomain = isBrowser() ? getSubDomain(window.location.hostname) : null;

  const router = useRouter();
  const isMobileView = typeof window !== "undefined" && window.innerWidth < 768;
  //   @ts-ignore
  const getCourses = useGetCoursesByTenantSlug();
  let referral = useIsSubdomain()
    ? currentUser?.referral ?? subDomain
    : currentUser?.referral;

  const referralCode =
    getCookie("ref_code_gk") && getCookie("ref_code_gk") !== "null"
      ? getCookie("ref_code_gk")
      : typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("referral")
      : "";

  const handleKeywordClick = (keys: any) => {
    onReset?.();

    setPageKeywords(1);
    setCoursesAfterClicked?.([]);
    setHasNextPage(true);

    const updatedKeywords = keywordOthers.map((el) =>
      el.name === keys.name
        ? { ...el, active: !el.active }
        : { ...el, active: false }
    );
    setKeywordOthers?.(updatedKeywords);

    const activeKeyword = updatedKeywords.find((k) => k.active);
    if (activeKeyword) {
      router.push({ pathname: "/" }, undefined, { shallow: true });

      if (referral && !["moodle", "example"].includes(referral)) {
        setIsLoadingKeywords(true);

        getCourses.doFetch(
          {
            slug:
              window.location.hostname === "e-learning.bluebirdgroup.com"
                ? "bluebird"
                : window.location.hostname === "lms.injourney.id"
                ? "injourney"
                : referral,
            "others[]": [activeKeyword.name],
            limit: itemsPerPage.toString(),
            // @ts-ignore
            page: 1,
          },
          {
            onSuccess(data) {
              const paginate = (data as any).meta.pagination;
              setCoursesAfterClicked?.(data.data);
              setDataPaginate((data as any).meta.total);
              setHasNextPage(paginate.current_page < paginate.total_pages);
              setIsLoadingKeywords(false);
            },
            onError(error) {
              setIsLoadingKeywords(false);
            },
          }
        );
      }
    }

    trackEventGTM({
      event: "keyword_chip_a",
      property: {
        user_id: currentUser?.id ?? "",
        is_logged_in: !!currentUser,
        keyword_name: keys.name,
      },
    });

    trackEventGA({
      event: "keyword_chip_a",
      property: {
        user_id: currentUser?.id ?? "",
        is_logged_in: !!currentUser,
        keyword_name: keys.name,
      },
    });
  };

  return (
    <HorizontalScroll
      className="md:mb-0 !gap-0"
      paddingHorizontal={0}
      top={12}
      useNavigation={!isMobileView}
    >
      {keywordOthers.map((keys: any) => (
        <div
          key={keys.name}
          className={`border rounded-full cursor-pointer px-12 py-8 text-center inline-flex flex-row items-center min-w-12 whitespace-nowrap m-8 ml-0 mr-8 md:mr-10 text-b2 font-light ${
            keys.active
              ? "bg-violet_main_to_dark_purple_surface text-white_to_white border-violet_main"
              : "border-light_neutral10_to_dark_neutral50 text-neutral80_to_dark10 bg-light_neutral10_to_dark_neutral50"
          }`}
          onClick={() => handleKeywordClick(keys)}
        >
          {keys.name}
        </div>
      ))}
    </HorizontalScroll>
  );
};

export default Keywords;
